import { makeStyles, shorthands, tokens, sliderCSSVars } from '@fluentui/react-components';

const { sliderDirectionVar, sliderProgressVar } = sliderCSSVars;


export const useStyles = makeStyles({
  player: {
    cursor: 'pointer',
    width: '100%',
    '&:hover .play-pause-btn': {
      backgroundColor: tokens.colorNeutralForeground1,
      color: tokens.colorNeutralBackground1,
    },
    '&:hover:active .play-pause-btn': {
      backgroundColor: tokens.colorNeutralForeground1,
      color: tokens.colorNeutralBackground1,
    },
  },
  playerContainer: {
    width: 'auto',
    maxHeight: '500px',
  },
  playerActions: {
    width: '100%',
    position: 'relative',
    bottom: '64px',
    display: 'flex',
    paddingTop: '12px',
    justifyContent: 'space-between',
    backgroundColor: 'transparent',
    background: 'linear-gradient(0deg,rgba(128, 128, 128, 1) 0%, transparent 100%)',
  },
  playPauseVolume: {
    textAlign: 'left',
    marginLeft: '10px',
  },
  timeAndDuration: {
    marginLeft: 'auto',
    marginRight: '10px',
  },
  playerScrubber: {
    width: '100%',
    paddingLeft: '5px',
    paddingRight: '5px',
    position: 'relative',
    display: 'flex',
    bottom: '64px',
    backgroundColor: 'transparent',
    background: 'linear-gradient(0deg,rgba(46, 46, 46, 1) 0%, rgba(128, 128, 128, 1) 100%)',
  },
  spinnerContainer: {
    marginTop: '220px',
    width: '100%',
  },
  spinnerOverlay: {
    marginTop: '150px',
  },
  playPause: {
    ...shorthands.border('none'),
    height: '24px',
    marginBottom: '9px',
    backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
    paddingTop: `${tokens.spacingVerticalXXS}`,
    paddingRight: `${tokens.spacingHorizontalS}`,
    paddingBottom: `${tokens.spacingVerticalXXS}`,
    paddingLeft: `${tokens.spacingHorizontalS}`,
    rowGap: `${tokens.spacingHorizontalXS}`,
    columnGap: `${tokens.spacingHorizontalXS}`,
    color: tokens.colorNeutralBackground5,
    ':hover': {
      backgroundColor: tokens.colorNeutralForeground1,
      color: tokens.colorNeutralBackground5,
    },
    ':hover:active': {
      backgroundColor: tokens.colorNeutralForeground1,
      color: tokens.colorNeutralBackground5,
    },
  },
  playerTimeSeparator: {
    ...shorthands.padding('0', tokens.spacingHorizontalXS),
  },
  scrubber: {
    width: '100%',
    gridTemplateColumns: '1fr 100% 1fr',
    '[data-fui-focus-within] .scrubber-thumb': {
      visibility: 'visible',
    },
    '[data-fui-focus-within] .scrubber-rail': {
      height: '4px',
      borderTopWidth: '1px',
      borderRightWidth: '1px',
      borderBottomWidth: '1px',
      borderLeftWidth: '1px',
      borderTopStyle: 'solid',
      borderRightStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderTopColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
      borderRightColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
      borderBottomColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
      borderLeftColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
    },
    '&:hover .scrubber-thumb': {
      visibility: 'visible',
    },
    '&:hover .scrubber-rail': {
      height: '4px',
    },
  },
  scrubberThumb: {
    visibility: 'hidden',
    backgroundColor: tokens.colorNeutralBackground1,
    borderTopWidth: '0px',
    borderRightWidth: '0px',
    borderBottomWidth: '0px',
    borderLeftWidth: '0px',
    boxShadow: '0px 1.6px 10px 0px rgba(0, 0, 0, 0.3), 0px 0px 0.9px 0px rgba(0, 0, 0, 0.4)',
  },
  scrubberRail: {
    '&:focus-visible .scrubber-thumb': {
      visibility: 'visible',
    },
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    '::before': {
      backgroundImage: 'none',
      '@media (forced-colors: active)': {
        backgroundImage: 'none',
      },
    },
  },
  durationTextContainer: {
    // width: '100%',
    height: '20px',
    paddingTop: '1px',
    paddingRight: '0px',
    paddingBottom: '3px',
    paddingLeft: '0px',
    rowGap: '0px',
    columnGap: '0px',
    opacity: '0px',
    // marginLeft: '8px'
    marginLeft: 'auto',
  },
  durationText: {
    color: tokens.colorBrandBackgroundInverted,
  },
  volumeControls: {
    rowGap: '0px',
    columnGap: '0px',
    display: 'inline-flex',
    height: '24px',
    width: '148px',
  },
  volumeButton: {
    fontWeight: '400',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
    height: '24px',
    minWidth: '24px',
    paddingTop: `${tokens.spacingVerticalXXS}`,
    paddingRight: `${tokens.spacingHorizontalXXS}`,
    paddingBottom: `${tokens.spacingVerticalXXS}`,
    paddingLeft: `${tokens.spacingHorizontalXXS}`,
    ...shorthands.border('none'),
    backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
    color: tokens.colorNeutralBackground1,
    '&:hover': {
      backgroundColor: tokens.colorNeutralForeground1,
      // backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
      color: tokens.colorNeutralBackground1,
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '0px',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '4px',
    },
    '[data-fui-focus-visible]': {
      // backgroundColor: tokens.colorNeutralForeground1,
      backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
      color: tokens.colorNeutralBackground1,
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '0px',
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '4px',
    },
  },
  volumeSlider: {
    fontWeight: '400',
    ...shorthands.border('1px'),
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '4px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '0px',
    width: '124px',
    height: '24px',
    minHeight: '24px',
    minWidth: '124px',
    backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
    '&:hover': {
      // backgroundColor: tokens.colorNeutralForeground1,
      backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
    },
    '[data-fui-focus-within]': {
      // backgroundColor: tokens.colorNeutralForeground1,
      backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
    },
  },
  volumeSliderThumb: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderColor(tokens.colorNeutralStroke1),
    ...shorthands.borderWidth('1px'),
  },
  volumeSliderRail: {
    backgroundImage: `linear-gradient(
          var(${sliderDirectionVar}),
          ${tokens.colorNeutralBackground1} 0%,
          ${tokens.colorNeutralBackground1} var(${sliderProgressVar}),
          ${tokens.colorNeutralStrokeAccessible} var(${sliderProgressVar})
        )`,
    '::before': {
      backgroundImage: 'none',
      '@media (forced-colors: active)': {
        backgroundImage: 'none',
      },
    },
  },
  volumeButtonFocused: {
    // backgroundColor: tokens.colorNeutralForeground1,
    backgroundColor: `color-mix(in srgb, ${tokens.colorNeutralForeground1} 0%, transparent)`,
    color: tokens.colorNeutralBackground1,
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '0px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '4px',
  },
});
